/**
 * @module useVRCEndDate
 * @description
 */
import { useEffect, useState, useContext } from 'react';
import { CustomCohesionContext } from 'ui/providers/cohesion';
import requestMonarch from 'ui/js/helpers/monarch';

export const useVRCEndDate = () => {
  const { cohesionReady } = useContext( CustomCohesionContext );
  const [ vrcEndDate, setVRCEndDate ] = useState( 'December 31, 2023' );

  useEffect( () => {
    if ( ! cohesionReady ) return;

    // @ts-ignore:next-line
    requestMonarch( 'rule', 'globalVRCEndDate', {}, {}, ( result ) => {
      if ( result?.globalVRCEndDate ) {
        setVRCEndDate( result.globalVRCEndDate );
      }
    } );
  }, [ cohesionReady ] );

  return vrcEndDate;
};

export default useVRCEndDate;
